export default __webpack_public_path__ + "media/images/wiz_newbanner-f910d7016ab85af4ae09243df86bf1bb.png";